const hosts = {
    dev: "https://oratur-backendweb.dev-api.digitelts.com/api/v1",
    ace: "https://oratur-backendweb.ace-api.digitelts.com/api/v1",
    pre: "https://oratur-backendweb.pre-api.digitelts.com/api/v1",
    pro: "https://oratur-backendweb.api.digitelts.com/api/v1",
};

const endpoints = {
    loginUrl: "/login",
    getContractInfo: "/getContracts",
    cancelContract: "/rejectContract",
    acceptContract: "/acceptContract",
};

const currentEnv = (process.env.ENV || "pre").toLowerCase();

const settings = Object.fromEntries(
  Object.entries(endpoints).map(([key, path]) => [key, `${hosts[currentEnv]}${path}`])
);


export default settings;


// WEBPACK FOOTER //
// ./src/settings.js